<div class="grid-container">
  <div class="filter-buttons-container">
    <wlm-grid-buttons
      *ngIf="gridSettings"
      [(gridSettings)]="gridSettings"
      [localGrid]="grid"
      [gridName]="gridName"
    >
    </wlm-grid-buttons>
  </div>
  <wlm-local-grid
    class="attributes-grid"
    #grid
    *ngIf="gridSettings"
    [gridSettings]="gridSettings"
    [gridData]="data"
    (selectedCellsChanged)="onSelectedItem($event)"
  ></wlm-local-grid>
</div>
